import { unwrapResult } from '@reduxjs/toolkit';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Text } from '@rsos/components/capstone/base';
import {
  setAgencyLinksFrom,
  updateAgency,
} from '@rsos/reduxDataStore/src/features/peerAgencies/peerAgenciesSlice';
import { notifyError } from '@rsos/utils/toastUtils';
import {
  Invitation,
  NotificationDeclineButton,
  NotificationAcceptButton,
} from './AgencyInvitation.styles';

const AgencyInvitation = () => {
  const dispatch = useDispatch();
  const { sinatra } = useSelector(state => state);
  const org = sinatra.user.currentOrg.name;
  const agencyLinksFrom = useSelector(
    state => state.peerAgencies.agencyLinks.linksFrom,
  );
  const acceptInvitation = (id, status) => {
    const data = {
      org,
      id,
      status,
    };
    dispatch(updateAgency(data))
      .then(unwrapResult)
      .then(response => {
        if (response) dispatch(setAgencyLinksFrom(response));
      })
      .catch(error => {
        notifyError(error);
      });
  };

  return agencyLinksFrom && agencyLinksFrom.length
    ? agencyLinksFrom.map(request => {
        const requestID = request.id;
        if (request.status === 'pending') {
          const agencyName = request.link_from.display_name;
          return (
            <Invitation key={requestID}>
              <Box horizontal>
                <Text size="large" fontWeight="bold" mr="3px">
                  New!
                </Text>
                <Text
                  data-name="agency-invitation"
                  lineHeight="inherit"
                  size="normal"
                >{`You have received an invitation from ${agencyName} to be a peer agency.`}</Text>
              </Box>
              <Box horizontal>
                <NotificationDeclineButton
                  dataName="decline-agency-invitation"
                  onClick={() => acceptInvitation(requestID, 'declined')}
                >
                  Decline
                </NotificationDeclineButton>
                <NotificationAcceptButton
                  dataName="accept-agency-invitation"
                  onClick={() => acceptInvitation(requestID, 'active')}
                >
                  Accept
                </NotificationAcceptButton>
              </Box>
            </Invitation>
          );
        }
      })
    : null;
};

export default AgencyInvitation;
